module.exports = __webpack_public_path__ + "static/media/fresh-jumbo.08c09f1b.jpg";